var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":"","color":"#f5f5f5"}},[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_c('a',{attrs:{"href":"https://www.cefriel.com"}},[_vm._v("Cefriel")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }